import React, { useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getItem, setItem } from '../../config/localStorage';

function AdditionalInformationModal(props) {
    const saveAffiliationEditorItem = getItem('additionalInformationData');
    const [additionalInformationEditor, setAdditionalInformationEditor] = useState(saveAffiliationEditorItem ? saveAffiliationEditorItem : '');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');


    const additionalInformationSubmit = (e) => {
        e.preventDefault();
        if (additionalInformationEditor === '') {
            setError('Please enter the additional information');
            setSuccess('');
        } else {
            setAdditionalInformationEditor(additionalInformationEditor);
            setSuccess('Thank you for providing your additional information details.');
            setItem('additionalInformationData', additionalInformationEditor);
            setError('');
        }
    };

    const additionalInformation = (event, editor) => {
        const content = editor.getData();
        setAdditionalInformationEditor(content);
        setSuccess('');
    }

    const editorConfiguration = {
        ui: {
            poweredBy: {
                forceVisible: false
            }
        },
        toolbar: [
            'bold',
            'italic',
        ],
        toolarLocation: 'bottom',
        placeholder: 'Enter your additoinal information'
    };

    const closePopUp = () => {
        setSuccess('')
        setError('')
    };

    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Additional Information
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={12}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={additionalInformationEditor}
                                    config={editorConfiguration}
                                    onChange={additionalInformation}
                                />
                            </Col>
                            {
                                error ? <Col md={12}> <div className="alert alert-danger mt-3" role="alert">{error}</div> </Col> : ''
                            }
                            {
                                success !== '' ? <Col md={12}> <div className="alert alert-success mt-3" role="alert">{success}</div> </Col> : ''
                            }
                            <Modal.Footer>
                                <Button className='button-green' type="submit" onClick={additionalInformationSubmit}>Save changes</Button>
                            </Modal.Footer>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AdditionalInformationModal
